(function () {
  if (window.__rebxTrustDrawers) return;
  window.__rebxTrustDrawers = true;

  function drawerFrom(id) {
    return document.querySelector('[data-rebx-trust-drawer="' + id + '"]');
  }

  function openDrawer(drawer) {
    if (!(drawer instanceof HTMLDialogElement) || drawer.open) return;
    if (drawer.parentElement !== document.body) document.body.appendChild(drawer);
    drawer.showModal();
    document.body.classList.add('rebx-trust-drawer-open');
  }

  function closeDrawer(drawer) {
    if (!(drawer instanceof HTMLDialogElement) || !drawer.open) return;
    drawer.close();
    if (!document.querySelector('dialog.rebx-trust-drawer[open]')) {
      document.body.classList.remove('rebx-trust-drawer-open');
    }
  }

  document.addEventListener('click', function (event) {
    var openBtn = event.target.closest('[data-rebx-trust-open]');
    if (openBtn) {
      event.preventDefault();
      openDrawer(drawerFrom(openBtn.getAttribute('data-rebx-trust-open')));
      return;
    }

    var closeBtn = event.target.closest('[data-rebx-trust-close]');
    if (closeBtn) {
      event.preventDefault();
      closeDrawer(closeBtn.closest('dialog'));
      return;
    }

    if (event.target.matches && event.target.matches('dialog.rebx-trust-drawer')) {
      closeDrawer(event.target);
    }
  });

  document.addEventListener('close', function (event) {
    if (event.target.matches && event.target.matches('dialog.rebx-trust-drawer')) {
      if (!document.querySelector('dialog.rebx-trust-drawer[open]')) {
        document.body.classList.remove('rebx-trust-drawer-open');
      }
    }
  }, true);
})();
